import { render, staticRenderFns } from "./_delegatesTable.vue?vue&type=template&id=7804b6e1"
import script from "./_delegatesTable.vue?vue&type=script&lang=js"
export * from "./_delegatesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports